var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.areaNegocioId == 15)?_c('SolicitudesInterify'):_vm._e(),(_vm.areaNegocioId == 3)?_c('SolicitudesLlamadas'):_vm._e(),(_vm.areaNegocioId == 6 || _vm.areaNegocioId == 3)?_c('SolicitudesEmails'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }